/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { VisualReference } from './VisualReference';
import {
    VisualReferenceFromJSON,
    VisualReferenceFromJSONTyped,
    VisualReferenceToJSON,
    VisualReferenceToJSONTyped,
} from './VisualReference';
import type { AnalysisResultCategory } from './AnalysisResultCategory';
import {
    AnalysisResultCategoryFromJSON,
    AnalysisResultCategoryFromJSONTyped,
    AnalysisResultCategoryToJSON,
    AnalysisResultCategoryToJSONTyped,
} from './AnalysisResultCategory';
import type { ScreenerAnalysisOverride } from './ScreenerAnalysisOverride';
import {
    ScreenerAnalysisOverrideFromJSON,
    ScreenerAnalysisOverrideFromJSONTyped,
    ScreenerAnalysisOverrideToJSON,
    ScreenerAnalysisOverrideToJSONTyped,
} from './ScreenerAnalysisOverride';
import type { CriteriaQualifier } from './CriteriaQualifier';
import {
    CriteriaQualifierFromJSON,
    CriteriaQualifierFromJSONTyped,
    CriteriaQualifierToJSON,
    CriteriaQualifierToJSONTyped,
} from './CriteriaQualifier';

/**
 * 
 * @export
 * @interface AnalysisResult
 */
export interface AnalysisResult {
    /**
     * 
     */
    id: string;
    /**
     * 
     */
    lead_id: string;
    /**
     * 
     */
    query: string;
    /**
     * 
     */
    criteria_id?: string;
    /**
     * 
     */
    category?: AnalysisResultCategory;
    /**
     * 
     */
    criteria_result: AnalysisResultCriteriaResultEnum;
    /**
     * 
     */
    reasoning: string;
    /**
     * 
     */
    date: string;
    /**
     * 
     */
    qualifier: CriteriaQualifier;
    /**
     * 
     */
    visual_references?: Array<VisualReference>;
    /**
     * 
     */
    deleted_at?: string;
    /**
     * 
     */
    is_medication_rule: boolean;
    /**
     * 
     */
    received_from_cache_key?: string;
    /**
     * 
     */
    latest_override?: ScreenerAnalysisOverride;
    /**
     * Indicates whether override history exists for this analysis result, even if the latest override is a revert
     */
    has_override_history?: boolean;
}


/**
 * @export
 */
export const AnalysisResultCriteriaResultEnum = {
    Pass: 'Pass',
    Fail: 'Fail',
    Unknown: 'Unknown',
    NA: 'N/A',
} as const;
export type AnalysisResultCriteriaResultEnum = typeof AnalysisResultCriteriaResultEnum[keyof typeof AnalysisResultCriteriaResultEnum];


/**
 * Check if a given object implements the AnalysisResult interface.
 */
export function instanceOfAnalysisResult(value: object): value is AnalysisResult {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('lead_id' in value) || value['lead_id'] === undefined) return false;
    if (!('query' in value) || value['query'] === undefined) return false;
    if (!('criteria_result' in value) || value['criteria_result'] === undefined) return false;
    if (!('reasoning' in value) || value['reasoning'] === undefined) return false;
    if (!('date' in value) || value['date'] === undefined) return false;
    if (!('qualifier' in value) || value['qualifier'] === undefined) return false;
    if (!('is_medication_rule' in value) || value['is_medication_rule'] === undefined) return false;
    return true;
}

export function AnalysisResultFromJSON(json: any): AnalysisResult {
    return AnalysisResultFromJSONTyped(json, false);
}

export function AnalysisResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): AnalysisResult {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'lead_id': json['lead_id'],
        'query': json['query'],
        'criteria_id': json['criteria_id'] == null ? undefined : json['criteria_id'],
        'category': json['category'] == null ? undefined : AnalysisResultCategoryFromJSON(json['category']),
        'criteria_result': json['criteria_result'],
        'reasoning': json['reasoning'],
        'date': json['date'],
        'qualifier': CriteriaQualifierFromJSON(json['qualifier']),
        'visual_references': json['visual_references'] == null ? undefined : ((json['visual_references'] as Array<any>).map(VisualReferenceFromJSON)),
        'deleted_at': json['deleted_at'] == null ? undefined : json['deleted_at'],
        'is_medication_rule': json['is_medication_rule'],
        'received_from_cache_key': json['received_from_cache_key'] == null ? undefined : json['received_from_cache_key'],
        'latest_override': json['latest_override'] == null ? undefined : ScreenerAnalysisOverrideFromJSON(json['latest_override']),
        'has_override_history': json['has_override_history'] == null ? undefined : json['has_override_history'],
    };
}

export function AnalysisResultToJSON(json: any): AnalysisResult {
    return AnalysisResultToJSONTyped(json, false);
}

export function AnalysisResultToJSONTyped(value?: AnalysisResult | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'lead_id': value['lead_id'],
        'query': value['query'],
        'criteria_id': value['criteria_id'],
        'category': AnalysisResultCategoryToJSON(value['category']),
        'criteria_result': value['criteria_result'],
        'reasoning': value['reasoning'],
        'date': value['date'],
        'qualifier': CriteriaQualifierToJSON(value['qualifier']),
        'visual_references': value['visual_references'] == null ? undefined : ((value['visual_references'] as Array<any>).map(VisualReferenceToJSON)),
        'deleted_at': value['deleted_at'],
        'is_medication_rule': value['is_medication_rule'],
        'received_from_cache_key': value['received_from_cache_key'],
        'latest_override': ScreenerAnalysisOverrideToJSON(value['latest_override']),
        'has_override_history': value['has_override_history'],
    };
}

